// extracted by mini-css-extract-plugin
export default {"root":"EVXOd","price":"_2vO50","saleOn":"CpPXq","preInstalled":"dcAAx","description":"JXJeQ","taxHeightCompensation":"xeD7Z","bottom":"MB0JN"};